export const viewingsAttributesIDs = {
  pauseViewingsWhenApprovedApplication:
    'pause_viewings_when_approved_application',
  displayPMContactInViewingReport: 'viewing_report_show_all_property_managers',
}
